import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../../lib/firebase';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Text,
  useToast,
  Link,
} from '@chakra-ui/react';

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      toast({
        title: 'Inicio de sesión exitoso',
        status: 'success',
        duration: 3000,
      });
      navigate('/');
    } catch (error: any) {
      console.error('Error de inicio de sesión:', error);
      toast({
        title: 'Error de inicio de sesión',
        description: 'Credenciales inválidas',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={8}>
      <form onSubmit={handleSubmit}>
        <VStack spacing={4}>
          <FormControl isRequired>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>Contraseña</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Tu contraseña"
            />
          </FormControl>
          <Box w="full" textAlign="right">
            <Link as={RouterLink} to="/olvide-contrasena" fontSize="sm" color="pitch.500">
              ¿Olvidaste tu contraseña?
            </Link>
          </Box>
          <Button
            type="submit"
            colorScheme="pitch"
            width="full"
            isLoading={loading}
          >
            Iniciar Sesión
          </Button>
          <Text>
            ¿No tienes una cuenta?{' '}
            <Link as={RouterLink} to="/register" color="blue.500">
              Regístrate aquí
            </Link>
          </Text>
        </VStack>
      </form>
    </Box>
  );
};

export default LoginForm; 